// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new bootstrap.Popover(el))

// Autofocus on search field on offcanvas open
document.querySelector('#offcanvas-search').addEventListener('shown.bs.offcanvas', () => {
    document.querySelector('#predictive-search-input').focus()
})

// Shopify's callenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
    ?.classList.add('btn-primary')

// Shopify's errors message - Add BS classes
const errors = document.querySelector('.errors')
if (errors) {
    errors.classList.add('alert', 'alert-danger')
    errors.querySelector('ul').classList.add('mb-0')
}

// CTA (call to action) button on Navbar change style on page scroll
const navbarBtn = document.querySelector('#navbar-collapse .nav-item .btn')
if (navbarBtn) {
    window.addEventListener('scroll', (e) => {
        if (window.scrollY > 0) {
            navbarBtn.classList.remove(navbarBtn.dataset.classCurrent)
            navbarBtn.classList.add(navbarBtn.dataset.classOnScroll)
        } else {
            navbarBtn.classList.remove(navbarBtn.dataset.classOnScroll)
            navbarBtn.classList.add(navbarBtn.dataset.classCurrent)
        }
    })
}

// Flipdown - Countdown timer
// https://github.com/PButcher/flipdown
document.querySelectorAll('.flipdown').forEach((el) => {
    new FlipDown(Number(el.dataset.countdownTime), el.id).start()
})

// Detect viewport
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
const initEnterViewAnimations = () => {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.querySelectorAll('.animate__animated').forEach((el) => {
                    el.classList.remove('opacity-0')
                    el.classList.add(el.dataset.animateClass)
                })
            }
        })
    }, { threshold: 0.25 })

    document.querySelectorAll('.enter-view').forEach((el) => {
        observer.observe(el)
    })
}
initEnterViewAnimations()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.enter-view')) {
        initEnterViewAnimations()
    }
})